import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { defineMessages, injectIntl, intlShape } from "react-intl";
import { Popconfirm, Modal, Button } from "antd";
import GreenFlag from "../green-flag/green-flag.jsx";
import StopAll from "../stop-all/stop-all.jsx";
import RunCodeBtn from "../runcode-btn/runcode-btn.jsx";
import ScratchBlocks from 'scratch-blocks';

import styles from "./btn-list.css";

import debugCIcon from "./icon--debugC.png";
import downloadIcon from "./icon--download-pycode.png";
import downloadCIcon from "./icon--download-ccode.png";
import downloadCIcon2 from "./icon--download-ccode2.png";
import debugIcon from "./icon--debug.png";
import backIcon from "./icon--back.png";
import dropdownCaret from "./dropdown-caret.svg";
import diskIcon from './disk.svg';

const messages = defineMessages({
    goTitle: {
        id: "gui.controls.go",
        defaultMessage: "Go",
        description: "Green flag button title",
    },
    stopTitle: {
        id: "gui.controls.stop",
        defaultMessage: "Stop",
        description: "Stop button title",
    },
    debugTitle: {
        id: "gui.controls.debug",
        defaultMessage: "Debug",
        description: "Debug button title",
    },
    downTitle: {
        id: "gui.controls.down",
        defaultMessage: "Download",
        description: "Download button title",
    },
    downCTitle: {
        id: "gui.controls.downC",
        defaultMessage: "DownloadC",
        description: "Download C button title",
    },
    download: {
        id: "gui.alerts.download",
        defaultMessage: "Download",
        description: "Default download button",
    },
    mobileDownload: {
        id: "gui.alerts.download",
        defaultMessage: "Download",
        description: "Default download button",
    },
    back: {
        id: "gui.modal.back",
        defaultMessage: "Back",
        description: "Back button"
    },
    backAndSave: {
        id: "gui.popconfirm.back",
        defaultMessage: "Save file on exit ?",
        description: "Back tip"
    }
});

// 五个按钮的判断
const btnArray = [
    ["role", "bg"],
    ["role", "bg", "E6", "M6", "C6", "C1", "A2", "E7", "M5"], //停止按钮
    ["E3"], // 单独一个下载c按钮
    ["C1", "A2"], //绿色运行按钮 绿色下载c按钮
    ["E6", "M6", "C6", "E7", "M5"], //调试按钮
    ["E6", "M6", "C6", "E7"], //下载python按钮
    ["STORM_OS"] //单独一个下载py按钮
];
const Btnlist = function (props) {
    const {
        active,
        className,
        intl,
        onGreenFlagClick,
        onStopAllClick,
        debugPythonClick,
        debugCClick,
        downloadC,
        downloadPython,
        downloadBtnBoxClick,
        defaultType,
        downloadBtnBoxClose,
        isRunPython,
        isRunC,
        defaultDownload,
        is_mobi,
        sendPyCodeToWindow,
        sendDebugToastToUnity,
        sendBackToastToUnity,
        backSaveToastToUnity,
        showModal,
        show,
        handleDownloadDesk,
        M5_download_show,
        handleM5Download,
        handleM5ShowModal,
        ...componentProps
    } = props;
    const type = localStorage.getItem(defaultType + "defaultDownloadType");
    return (
        <div>
            {!is_mobi ? (
                <div
                    className={classNames(styles.controlBtn, className)}
                    {...componentProps}
                >
                    {/* 角色和背景专用的按钮 */}
                    {btnArray[0].indexOf(defaultType) != -1 ? (
                        <div className={styles.runningBox}>
                            <GreenFlag
                                active={active}
                                title={intl.formatMessage(messages.goTitle)}
                                onClick={onGreenFlagClick}
                            />
                            <StopAll
                                active={active}
                                title={intl.formatMessage(messages.stopTitle)}
                                onClick={onStopAllClick}
                            />
                        </div>
                    ) : null}

                    {/* 使用c语言调试和停止按钮 （小车）*/}
                    {btnArray[3].indexOf(defaultType) != -1 ? (
                        <div className={styles.runningBox}>
                            <RunCodeBtn
                                active={active}
                                className={classNames({
                                    [styles.hide]: isRunC === true,
                                })}
                                title={intl.formatMessage(messages.goTitle)}
                                onClick={(e) => {
                                    debugCClick("c", e);
                                }}
                                imgSrc={debugCIcon}
                            />
                            <StopAll
                                className={classNames({
                                    [styles.hide]: isRunC === false,
                                })}
                                active={active}
                                title={intl.formatMessage(messages.stopTitle)}
                                onClick={(e) => {
                                    onStopAllClick(e, "c");
                                }}
                            />
                        </div>
                    ) : null}

                    {/* 使用python语言调试和停止按钮 */}
                    {btnArray[4].indexOf(defaultType) != -1 ? (
                        <div className={styles.runningBox}>
                            {
                                defaultType == "M5" ? <React.Fragment>
                                    {
                                        active ? <StopAll
                                            active={active}
                                            title={intl.formatMessage(messages.stopTitle)}
                                            onClick={(e) => {
                                                onStopAllClick(e, "python");
                                            }}
                                        /> : <RunCodeBtn
                                            active={active}
                                            className={classNames(className)}
                                            title={intl.formatMessage(messages.debugTitle)}
                                            onClick={(e) => {
                                                debugPythonClick("python", e);
                                            }}
                                            imgSrc={debugCIcon}
                                        />
                                    }
                                </React.Fragment> : <React.Fragment>
                                    <StopAll
                                        className={classNames({
                                            [styles.hide]: isRunPython === false,
                                        })}
                                        active={active}
                                        title={intl.formatMessage(messages.stopTitle)}
                                        onClick={(e) => {
                                            onStopAllClick(e, "python");
                                        }}
                                    />
                                    <RunCodeBtn
                                        active={active}
                                        className={classNames(className, {
                                            [styles.hide]: isRunPython === true,
                                        })}
                                        title={intl.formatMessage(messages.debugTitle)}
                                        onClick={(e) => {
                                            debugPythonClick("python", e);
                                        }}
                                        imgSrc={debugCIcon}
                                    />
                                </React.Fragment>
                            }

                        </div>
                    ) : null}

                    {/* 下载C按钮（绿色图标版），在C1、A2界面显示*/}
                    {btnArray[3].indexOf(defaultType) != -1 ? (
                        <RunCodeBtn
                            className={classNames(styles.download, className)}
                            title={intl.formatMessage(messages.downCTitle)}
                            onClick={downloadC}
                            imgSrc={downloadCIcon2}
                        ></RunCodeBtn>
                    ) : null}

                    {/* 下载c按钮（蓝色C图标版，在E3界面显示 */}
                    {btnArray[2].indexOf(defaultType) != -1 ? (
                        <RunCodeBtn
                            className={classNames(className)}
                            title={intl.formatMessage(messages.downCTitle)}
                            onClick={downloadC}
                            imgSrc={downloadCIcon}
                        ></RunCodeBtn>
                    ) : null}


                    {/* 下载python按钮 */}
                    {btnArray[6].indexOf(defaultType) != -1 ? (
                        <RunCodeBtn
                            className={classNames(className)}
                            title={intl.formatMessage(messages.downTitle)}
                            onClick={downloadPython}
                            imgSrc={downloadIcon}
                        ></RunCodeBtn>
                    ) : null}


                    {/* 收纳两种下载方式的按钮 */}
                    {btnArray[4].indexOf(defaultType) != -1 ? (
                        <div className={styles.downloadBox}>
                            {/* 绿色下载按钮 */}
                            <RunCodeBtn
                                active={active}
                                className={classNames(className)}
                                title={intl.formatMessage(messages.download)}
                                onClick={defaultDownload}
                                imgSrc={downloadCIcon2}
                            ></RunCodeBtn>
                            {/* 展开小按钮 */}
                            <RunCodeBtn
                                className={classNames(styles.pullDown, {
                                    [styles.pullUp]: downloadBtnBoxClose !== 0,
                                })}
                                onClick={downloadBtnBoxClick}
                                imgSrc={dropdownCaret}
                            ></RunCodeBtn>
                            {/* 列开的两个下载按钮 */}
                            <div
                                className={classNames(styles.downloadItemBox, {
                                    [styles.downloadItemBoxShow]:
                                        downloadBtnBoxClose === 0,
                                })}
                            >
                                {/* 下载python按钮 */}
                                <div
                                    className={classNames(styles.downloadItem, {
                                        [styles.downloadItemChecked]:
                                            type === "python",
                                    })}
                                    onClick={() => {
                                        downloadBtnBoxClick(), downloadPython();
                                    }}
                                >
                                    <RunCodeBtn
                                        className={classNames(className)}
                                        title={intl.formatMessage(
                                            messages.downTitle
                                        )}
                                        onClick={() => { }}
                                        imgSrc={downloadIcon}
                                    />
                                </div>
                                {/* 下载c按钮 */}
                                {defaultType == "E7" ? null : <div
                                    className={classNames(styles.downloadItem, {
                                        [styles.downloadItemChecked]:
                                            type === "c",
                                    })}
                                    onClick={() => {
                                        downloadBtnBoxClick(), downloadC();
                                    }}
                                >
                                    <RunCodeBtn
                                        className={classNames(className)}
                                        title={intl.formatMessage(
                                            messages.downCTitle
                                        )}
                                        onClick={() => { }}
                                        imgSrc={downloadCIcon}
                                    />
                                </div>}
                                {defaultType == "E7" ? (<div
                                    className={classNames(styles.downloadItem, {
                                        [styles.downloadItemChecked]:
                                            type === "disk",
                                    })}
                                    onClick={() => {
                                        let xml = ScratchBlocks.Xml.workspaceToDom(window.workspace)
                                        xml = ScratchBlocks.Xml.domToText(xml)
                                        xml = `"${xml}"`
                                        let a = document.createElement('a')
                                        let url = new Blob([xml])
                                        url = URL.createObjectURL(url)
                                        a.download = 'xmlFile.xml'
                                        a.href = url
                                        a.click()
                                        a.remove()
                                    }}
                                >
                                    <RunCodeBtn
                                        className={classNames(className)}
                                        title="下载xml文件"
                                        onClick={() => { }}
                                        imgSrc={diskIcon}
                                    />
                                </div>) : null}
                            </div>
                        </div>
                    ) : null}

                    <Modal
                        visible={M5_download_show}
                        title="下载"
                        footer={null}
                        onCancel={handleM5ShowModal}
                    >
                        <div className={styles.downloadContainerClass}>
                            {["A", "B", "C", "D"].map((item) => {
                                return <div
                                    className={styles.downloadItemClass}
                                    key={item}
                                    onClick={() => {
                                        handleM5Download(item)
                                    }}
                                >
                                    {item}
                                </div>
                            })}
                        </div>
                    </Modal>
                </div>
            ) : (
                <div>
                    <RunCodeBtn
                        className={classNames(styles.download, className)}
                        title={intl.formatMessage(messages.debugTitle)}
                        onClick={sendDebugToastToUnity}
                        imgSrc={debugCIcon}
                    ></RunCodeBtn>
                    <RunCodeBtn
                        className={classNames(styles.download, className)}
                        title={intl.formatMessage(messages.mobileDownload)}
                        onClick={sendPyCodeToWindow}
                        imgSrc={downloadCIcon2}
                    ></RunCodeBtn>
                    {/* <Popconfirm
                        title={intl.messages["gui.popconfirm.back"]}
                        onConfirm={backSaveToastToUnity}
                        onCancel={sendBackToastToUnity}
                        okText={intl.messages["JMD_YES"]}
                        cancelText={intl.messages["JMD_NO"]}
                    >
                        <a href="#">
                            <RunCodeBtn
                                className={classNames(
                                    styles.download,
                                    className
                                )}
                                title={intl.formatMessage(
                                    messages.mobileDownload
                                )}
                                onClick={() => {}}
                                imgSrc={backIcon}
                            ></RunCodeBtn>
                        </a>
                    </Popconfirm> */}
                    <RunCodeBtn
                        className={classNames(styles.download, className)}
                        title={intl.formatMessage(messages.back)}
                        onClick={showModal}
                        imgSrc={backIcon}
                    ></RunCodeBtn>

                    <Modal
                        width="200px"
                        visible={show}
                        mask={true}
                        onCancel={showModal}
                        footer={[
                            <Button key="backSave" onClick={backSaveToastToUnity} type="primary">
                                {intl.messages["JMD_YES"]}
                            </Button>,
                            <Button key="back" onClick={sendBackToastToUnity} type="danger">
                                {intl.messages["JMD_NO"]}
                            </Button>
                        ]}
                    >
                        {intl.formatMessage(messages.backAndSave)}
                    </Modal>
                </div>
            )}
        </div>
    );
};

Btnlist.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    downloadPython: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    debugPythonClick: PropTypes.func.isRequired,
    downloadC: PropTypes.func.isRequired,
    debugCClick: PropTypes.func.isRequired,
};

Btnlist.defaultProps = {
    active: false,
};

export default injectIntl(Btnlist);
